import React from 'react'
import PropTypes from 'prop-types'
import { DotsVerticalIcon } from '@heroicons/react/outline'
import clsx from 'clsx'
// import ClickAwayListener from 'react-click-away-listener'

const Option = ({
    index,
    label,
    icon,
    onClick,
    rowData,
    sizeOptions,
    toggleOpen,
}) => {
    const isLast = index === sizeOptions - 1

    return (
        <button
            onClick={() => {
                toggleOpen()
                onClick(rowData)
            }}
            className={clsx(
                'w-full rounded-none h-auto px-4 py-2 flex items-center justify-start',
                !isLast && 'border-b border-solid border-grayLines',
            )}
        >
            {icon}
            <span className="text-sm font-medium text-textDarkerGray ml-1.5">
                {label}
            </span>
        </button>
    )
}

Option.propTypes = {
    label: PropTypes.string,
    icon: PropTypes.element,
    onClick: PropTypes.func,
    rowData: PropTypes.object,
    sizeOptions: PropTypes.number,
    index: PropTypes.number,
    toggleOpen: PropTypes.func.isRequired,
}

const OptionsRow = ({
    activeOption,
    setActiveOption,
    options = [],
    rowData,
    isLast,
}) => {
    const sizeOptions = options?.length
    const isActive = activeOption?.id === rowData?.id
    const validOptions = options?.filter(option => option?.isValid(rowData))
    const hasValidOptions = validOptions?.length > 0

    const toggleOpen = () => {
        if (activeOption?.id === rowData?.id) {
            setActiveOption(null)
        } else {
            setActiveOption(rowData)
        }
    }

    return (
        hasValidOptions && (
            <div className="w-14 h-full z-100 flex justify-center items-center select-none">
                <div className="w-auto h-auto relative">
                    <DotsVerticalIcon
                        role="button"
                        className="text-textDarkGray stroke-2 w-6 stroke-current"
                        onClick={toggleOpen}
                    />

                    {isActive && (
                        <div
                            className={clsx(
                                isLast && 'bottom-0',
                                'transition-opacity absolute w-40 h-auto bg-white shadow-lg z-50 border border-grayLines rounded-md right-6',
                            )}
                        >
                            {validOptions.map((option, index) => {
                                return (
                                    <Option
                                        sizeOptions={sizeOptions}
                                        rowData={rowData}
                                        key={index}
                                        index={index}
                                        toggleOpen={toggleOpen}
                                        {...option}
                                    />
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>
        )
    )
}

OptionsRow.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            icon: PropTypes.element,
            onClick: PropTypes.func,
        }),
    ),
    rowData: PropTypes.object,
    activeOption: PropTypes.object,
    setActiveOption: PropTypes.func,
    isLast: PropTypes.bool,
}

export default OptionsRow
